import { FC } from "react";
import { useNavigate } from "react-router-dom";
import { Button, ButtonGroup } from "@mui/material";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
type SubmissionToggleProps = {
  activeMode: "time-study" | "task-counter";
};

const activeStyle = {
  backgroundColor: "#E0F2FE",
  color: "#203C77",
  textTransform: "capitalize" as const,
  fontWeight: 400,
  fontSize: "15px",
  padding: "7px 16px",
  borderColor: "#EBF2FE",
  "&:hover": {
    backgroundColor: "#BAE6FD",
    borderColor: "#EBF2FE",
  },
};

const inactiveStyle = {
  backgroundColor: "#fff",
  color: "#203C77",
  textTransform: "capitalize" as const,
  fontWeight: 400,
  fontSize: "15px",
  padding: "7px 16px",
  borderColor: "#EBF2FE",
  "&:hover": {
    backgroundColor: "#f0f4fa",
    borderColor: "#EBF2FE",
  },
};

export const SubmissionToggle: FC<SubmissionToggleProps> = ({ activeMode }) => {
  const navigate = useNavigate();

  return (
    <ButtonGroup variant="outlined" size="small">
      <Button
        sx={activeMode === "time-study" ? activeStyle : inactiveStyle}
        onClick={() => navigate("/task-submission")}
      >
        <TimerOutlinedIcon fontSize="small" sx={{ marginRight: "5px" }} />
        Time Study
      </Button>
      <Button
        sx={activeMode === "task-counter" ? activeStyle : inactiveStyle}
        onClick={() => navigate("/task-counter-submission")}
      >
        <TaskAltIcon fontSize="small" sx={{ marginRight: "5px" }} />
        Task Counter
      </Button>
    </ButtonGroup>
  );
};
